import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6ZM12 16.43C9.55 16.43 7.57 14.44 7.57 12C7.57 9.56 9.55 7.57 12 7.57C14.45 7.57 16.43 9.56 16.43 12C16.43 14.44 14.44 16.43 12 16.43ZM12.52 12.22L14.29 13.84L13.23 15L10.95 12.91V9.14H12.52V12.22Z" fill={ fill || 'currentColor' } />
    </svg>
);
